<div class="SectionItem__loading loadingDiv" *ngIf="showLoading">
  <div class="loading-indicator -compact">
    <div class="block-1"></div>
    <div class="block-2"></div>
    <div class="block-3"></div>
    <div class="block-4"></div>
    <div class="block-5"></div>
  </div>
</div>
<table class="generic-table">
  <thead class="-sticky">
    <tr>
      <th>
        Date
      </th>
      <th style="min-width: 150px;">Status</th>
      <th>Created by</th>
      <th>Created at</th>
      <th>Handler</th>
      <th>Staff</th>
      <th>Labour/People</th>
      <th>Plant/Equipment</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody class="results-tbody work-package--results-tbody">
    <tr  *ngFor="let item of list">
      <td>{{item.daily_date}}</td>
      <td>{{getstateName(item.state)}}</td>
      <td class="defaultWidth">{{item.user_name}}</td>
      <td class="defaultWidth">{{item.created_at}}</td>
      <td class="handlerwidth">
        {{item.pm_user.name + ', ' + item.contractor_signer.name + ', ' + item.supervisor_signer.name}}
      </td>
      <td class="defaultWidth">{{item.site_staff}}.0</td>
      <td class="defaultWidth">{{item.labour_items}}.0</td>
      <td>{{item.plant_working}}.0/{{item.plant_ldle}}.0</td>
      <td class="tableButtonCase" width="410">
        <div class="tablebutton">
        <div (click)="listItemClick('edit',item.id)" style="background-color: #2f8bc7; min-width: 50px;">{{item.state.includes('signed')? 'View': 'Edit'}}</div>
        <div (click)="listItemClick('view',item)" [style.visibility]="item.state == 'supervisor_signed'? 'hidden': 'visible'" style="background-color:#4eb862">Assign Next</div>
        <div (click)="listItemClick('delete',item)" style="background-color: #e15353;"
        [style.visibility]="item.state == 'draft'? 'visible': 'hidden'" >Delete</div>
        <div (click)="getPdfHref(item.id,  item.daily_date , 'pdf2')" style="background-color: #45c0dc;position: relative;">PDF
        </div>
        <div (click)="listItemClick('copy' ,item.id)" style="border: #448efc 2px solid; color: #448efc;">copy</div>
          <div (click)="changStatus(item.id)"  *ngIf="isUserAdmin" style="background-color: #dcbe45;min-width: 50px; line-height: 28px;" >
            Reset
          </div>
          <div (click)="changeTime(item.id)"  *ngIf="isUserAdmin" style="background-color: #6c45dc;min-width: 50px; line-height: 28px;" >
            Sign Time
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<!-- 添加弹窗 -->
<!-- <SiteDiary-List-Popup *ngIf="topopup" type='create' (close)="addSiteDiaryList($event, 'edit')"></SiteDiary-List-Popup> -->
<SiteDiary-List-Popup-MyAction *ngIf="toCopyPopup" type='copy' [id]='copyId' (close)="addSiteDiaryList($event, 'copy')"></SiteDiary-List-Popup-MyAction>
<SiteDiary-List-Approval-MyAction *ngIf="approval" [itemSiteDiary]="itemSiteDiary" (close)="approvalClose($event)"></SiteDiary-List-Approval-MyAction>